import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "./RecommendedServices.css";
import { Link } from "react-router-dom";
import { fetchAllProperties } from "../../redux/Slices/AllPropertiesSlice";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import CardsLoader from "../../pages/CardsLoader";
const RecommendedProperties = () => {
  const { t, i18n } = useTranslation("global");
  const swiperKey = useMemo(() => `swiper-${i18n.language}`, [i18n.language]);
  const isRTL = i18n.language === "ar";
  const dispatch = useDispatch();
  const { properties, isLoading } = useSelector((state) => state.properties);
  useEffect(() => {
    dispatch(fetchAllProperties({type : "all"}));
  }, [dispatch,i18n.language]);
  
  return (
    <div className="recommended_services py-5">
      <div className="container-fluid">
        <h3 className="mb-4 text-center fw-bold main-color">
          {t("property.title")}
        </h3>
        {isLoading ? (
          <CardsLoader />
        ) : properties.length > 0 ? (
          <Swiper
            modules={[Navigation, Autoplay]}
            spaceBetween={20}
            navigation
            loop={true}
            key={swiperKey}
            dir={isRTL ? "rtl" : "ltr"}
            autoplay={{
              delay: 2500,
              disableOnInteraction: false,
            }}
            pagination={{ clickable: true }}
            breakpoints={{
              0: {
                slidesPerView: 1,
              },
              576: {
                slidesPerView: 2,
              },
              768: {
                slidesPerView: 3,
              },
              992: {
                slidesPerView: 4,
              },
            }}
          >
            {properties.map((item, index) =>
              item.is_recommended === true &&
                <SwiperSlide key={item.id || index}>
                  <Link
                    key={item.id || index}
                    to={`/propertyDetails/${item.id}`}
                    className="d-block recommended_card border rounded-4 my-2 overflow-hidden position-relative"
                  >
                    <div className="finishing_status">
                      {item?.category?.name ? item?.category?.name : t("labels.undefined")}
                    </div>
                    <img
                      src={item.images?.[0]?.url || "/placeholder.jpg"}
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = "/placeholder.jpg";
                      }}
                      alt={item.title}
                      className="img-fluid mb-3 rounded-4"
                    />
                    <div className="p-3">
                      <p className="line-height mb-1 text-dark">
                        {item.title?.slice(0, 60)}...
                      </p>
                      <hr className="my-1" />
                      <ul className="p-0 mb-0 list-unstyled">
                        <li className="text-sm bg-blue text-white d-block rounded-5 px-2 py-1 my-1 mx-3 text-center">
                          <small>{t("property.unitCategory")}</small> :{" "}
                          <small>
                            {item?.purpose?.name ? item?.purpose?.name : t("labels.undefined")}
                          </small>
                        </li>
                        <li className="text-sm bg-success text-white d-block rounded-5 px-2 py-1 my-1 mx-3 text-center">
                          <small>{t("property.unitType")}</small> :{" "}
                          <small>
                            {item?.property_type?.name ? item?.property_type?.name : t("labels.undefined")}
                          </small>
                        </li>
                      </ul>
                      <hr className="my-1" />

                      <div className="text-sm d-flex justify-content-between align-items-center">
                        <div className="text-dark">
                          {t("recommendedServices.startingFrom")}{" "}
                          <span className="fw-bold">
                            {item?.price ? `${item?.price} ${t("recommendedServices.currency")}` : t("labels.undefined")}
                          </span>
                        </div>
                        <div>
                          <span className="view_details">
                            <i
                              className={`text-sm bi ${
                                i18n.language === "ar"
                                  ? "bi-arrow-left"
                                  : "bi-arrow-right"
                              }`}
                            ></i>
                          </span>
                        </div>
                      </div>
                    </div>
                  </Link>
                </SwiperSlide>
              
            )}
          </Swiper>
        ) : (
          <div className="no_data bg-white py-5 border rounded-2 my-3 text-center">
            <h5 className="mb-0 text-sm">{t("no_data_exists")}</h5>
          </div>
        )}
        {properties.length > 0 && (
          <div className="text-center">
            <Link className="show_more" to="/all_properties">
              {t("recommendedServices.showMore")}{" "}
              <i
                className={`bi ${
                  i18n.language === "ar" ? "bi-arrow-left" : "bi-arrow-right"
                }`}
              ></i>
            </Link>
          </div>
        )}
      </div>
    </div>
  );
};

export default RecommendedProperties;
